import { Navigate } from "react-router-dom";

export const PosIndexPage = () => {
  return <Navigate to="sell" />;
};
